export default {
      id: "common__boat-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.svg#common__boat",
      toString: function () {
        return this.url;
      }
    }